var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasText())?_c('span',{on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),_c('span',{on:{"click":_vm.handleClick}},[_c('i',{staticClass:"material-icons bold"},[_vm._v("arrow_back")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e49a1130","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoBackButton.vue
// module id = null
// module chunks = 